/**
 * AuditLogGuard — route-level gate for the Audit Log, blocking the screen BEFORE
 * it mounts so the log is never even read for an account that may not see it.
 * A notice rather than a redirect, for the reason SubconGuard gives: bouncing
 * somebody to Home says the URL does not exist, which is untrue. See
 * auditAccess.ts for the list, and for why this gates the UI and not the data.
 */
import type { ReactNode } from "react";
import { useAuditLogAccess } from "./auditAccess";

export function AuditLogGuard({ children }: { children: ReactNode }): JSX.Element {
  if (useAuditLogAccess()) return <>{children}</>;
  return (
    <div className="restricted-screen">
      <div className="restricted-icon" aria-hidden="true">🔒</div>
      <div className="restricted-title">Restricted</div>
      <div className="restricted-message">
        The Audit Log records when each person used i-SYNERGY and for how long, and is limited to the
        accounts authorised for it. Contact the owner if you believe you should have access.
      </div>
    </div>
  );
}
